// extracted by mini-css-extract-plugin
export var productPartTwo = "productPartTwo-module--productPartTwo--aadDS";
export var productTwoBg = "productPartTwo-module--productTwoBg--4FLWA";
export var productTwoText = "productPartTwo-module--productTwoText--trvmQ";